import { 
    IDI_DASHBOARD_START_LOADING, 
    IDI_DASHBOARD_END_LOADING,
    SET_IDI_DASHBOARD_FILTER_SEARCH,
    IDI_DASHBOARD_DRAFT_LOADED, 
    IDI_DASHBOARD_NEW_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED,
    IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED,
    IDI_DASHBOARD_FOUNDATION_LOADED,
    IDI_DASHBOARD_GROUND_BEAM_LOADED,
    IDI_DASHBOARD_COLUMNS_LOADED,
    IDI_DASHBOARD_SLAB_LOADED,
    IDI_DASHBOARD_WATER_PROOFING_LOADED,
    IDI_DASHBOARD_FINISHES_LOADED,
    IDI_DASHBOARD_PROJECT_COMPLETION_LOADED,
    IDI_DASHBOARD_COMPLETED_LOADED,
    IDI_DASHBOARD_CLOSED_LOADED,
    IDI_DASHBOARD_CANCELLED_LOADED,
    IDI_DASHBOARD_ABORTED_LOADED,
    IDI_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IdiDashboardConstants";

const initialState = {
    loading: false,
    search: "",
    draftList: [],
    newList: [],
    designReviewList: [],
    designReviewAcceptedList: [],
    designReviewRejectedList: [],
    uploadedToBaladyList: [],
    foundationList: [],
    groundBeamList: [],
    columnsList: [],
    slabList: [],
    waterproofingList: [],
    finishesList: [],
    projectCompletionList: [],
    completedList: [],
    closedList: [],
    cancelledList: [],
    abortedList: [],
    searchList: []
};

const IdiDashboardReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_DASHBOARD_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_DASHBOARD_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_IDI_DASHBOARD_FILTER_SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case IDI_DASHBOARD_DRAFT_LOADED:
            return {
                ...state,
                draftList: action.payload
            };
        case IDI_DASHBOARD_NEW_LOADED:
            return {
                ...state,
                newList: action.payload
            };
        case IDI_DASHBOARD_DESIGN_REVIEW_LOADED:
            return {
                ...state,
                designReviewList: action.payload
            };
        case IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED:
            return {
                ...state,
                designReviewAcceptedList: action.payload
            };
        case IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED:
            return {
                ...state,
                designReviewRejectedList: action.payload
            };
        case IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED:
            return {
                ...state,
                uploadedToBaladyList: action.payload
            };
        case IDI_DASHBOARD_FOUNDATION_LOADED:
            return {
                ...state,
                foundationList: action.payload
            };
        case IDI_DASHBOARD_GROUND_BEAM_LOADED:
            return {
                ...state,
                groundBeamList: action.payload
            };
        case IDI_DASHBOARD_COLUMNS_LOADED:
            return {
                ...state,
                columnsList: action.payload
            };
        case IDI_DASHBOARD_SLAB_LOADED:
            return {
                ...state,
                slabList: action.payload
            };
        case IDI_DASHBOARD_WATER_PROOFING_LOADED:
            return {
                ...state,
                waterproofingList: action.payload
            };
        case IDI_DASHBOARD_FINISHES_LOADED:
            return {
                ...state,
                finishesList: action.payload
            };
        case IDI_DASHBOARD_PROJECT_COMPLETION_LOADED:
            return {
                ...state,
                projectCompletionList: action.payload
            };
        case IDI_DASHBOARD_COMPLETED_LOADED:
            return {
                ...state,
                completedList: action.payload
            };
        case IDI_DASHBOARD_CLOSED_LOADED:
            return {
                ...state,
                closedList: action.payload
            };
        case IDI_DASHBOARD_CANCELLED_LOADED:
            return {
                ...state,
                cancelledList: action.payload
            };
        case IDI_DASHBOARD_ABORTED_LOADED:
            return {
                ...state,
                abortedList: action.payload
            };
        case IDI_DASHBOARD_USER_SEARCH_LOADED:
            return {
                ...state,
                searchList: action.payload
            };
        default:
            return state;
    }
}

export default IdiDashboardReducer;